import { render, staticRenderFns } from "./QuestionStatus.vue?vue&type=template&id=2698aa5e&scoped=true&"
import script from "./QuestionStatus.vue?vue&type=script&lang=js&"
export * from "./QuestionStatus.vue?vue&type=script&lang=js&"
import style0 from "./QuestionStatus.vue?vue&type=style&index=0&id=2698aa5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2698aa5e",
  null
  
)

export default component.exports